<template>
    <div class="wisdom-training">
        <div v-if="!isAuthorized&&errorMessage!=''" class="auth-failed">
            <h2>权限验证失败</h2>
            <p>{{ errorMessage }}</p>
            <button @click="retryAuth">重新验证</button>
        </div>
        <div v-else-if="!isAuthorized&&errorMessage==''" class="auth-failed">
            <p>正在验证权限...</p>
        </div>
        <div v-else class="auth-success">
            <h2>权限验证成功</h2>
            <!-- <p>您可以访问智练功能</p> -->
            <div class="training-content">
                <!-- 智练功能内容 -->
                <p>欢迎使用{{ errorMessage }}功能！</p>
            </div>
        </div>
    </div>
</template>

<script>
import { MD5 } from 'crypto-js'
import { Utils } from 'elegant-tools-js';
import { goodsInfoDetail } from '@/api/bookstore/bookstore'
import { setBrowserToken } from "@/utils/auth.js"
import {xueKeKnowledgeBase} from "@/utils/config"
export default {
    name: 'WisdomTraining',
    data() {
        return {
            // 秘钥 - 由云书院分配给合作方
            SECRET_KEY: 'read-crtvup*123.cv987@', // 请替换为实际的秘钥
            userId: '123',
            goodsId: '1902973514156216320',
            timestamp: '',
            platform: 'xueKeKnowledgeBaseSys', // 平台标识，可根据需要调整
            browserFinger: '',//浏览器指纹
            sign: '',
            isAuthorized: false,
            errorMessage: '',
            goodsInfo: {}
        }
    },
    methods: {
        // 签名校验函数
        verifySignature() {
            try {
                // 1. 获取路由参数
                this.userId = this.$route.query.userId || ''
                this.goodsId = this.$route.query.goodsId || ''
                this.timestamp = this.$route.query.timestamp || ''
                this.browserFinger = this.$route.query.browserFinger || ''
                this.platform = this.$route.query.platform || ''
                this.sign = this.$route.query.sign || ''
                
                if(process.env.VUE_APP_ENV=='development'){
                    this.queryPermission()
                    return true
                }
                // // // 2. 参数校验
                if (!this.userId || !this.goodsId || !this.timestamp || !this.browserFinger || !this.platform || !this.sign) {
                    this.errorMessage = '缺少必要参数'
                    return false
                }

                // 3. 验证时间戳是否过期（可选，例如10分钟有效期）
                const now = Date.now()
                const paramTime = parseInt(this.timestamp)
                const expires = 10 * 60 * 1000 // 10分钟
                if (now - paramTime > expires) {
                    this.errorMessage = '链接已过期'
                    return false
                }

                // 4. 签名参数集合
                const params = {
                    userId: this.userId,
                    goodsId: this.goodsId,
                    platform: this.platform,
                    timestamp: this.timestamp
                }

                // 5. 将参数按键名排序并拼接字符串
                const sortedKeys = Object.keys(params).sort()
                const paramString = sortedKeys
                    .map(key => `${key}=${params[key]}`)
                    .join('&')

                // 6. 加盐加密：在字符串S末尾拼接秘钥key
                const stringToSign = paramString + this.SECRET_KEY

                // 7. 对S1进行MD5加密
                const computedSign = MD5(stringToSign).toString().toUpperCase()
                console.log(computedSign, 'stringToSign');


                // 8. 比较签名
                if (computedSign != this.sign.toUpperCase()) {
                    this.errorMessage = '签名验证失败'
                    return false
                }
                let browserFinger = Utils.getBrowserFingerprint()
                console.log(browserFinger, 'kkkkkkkkkkkkkkkk');

                if (browserFinger !== this.browserFinger) {
                    this.errorMessage = '浏览器指纹验证失败'
                    return false
                }
                this.queryPermission()
            } catch (error) {
                this.errorMessage = `验证过程出错: ${error.message}`
                return false
            }
        },

        // 查询使用权限
        queryPermission() {
            goodsInfoDetail(this.goodsId).then((res) => {
                if (!res.data.sourceList?.length) {
                    this.errorMessage = '内容不存在'
                    return false
                }
                let type=""
                if (res.data.sourceList[0]?.resourceType == "bank") {// 题库
                    type="11"
                } else if (res.data.goods.goodsType == 'paper') {//试卷
                    type="11"
                } else if (res.data.goods.goodsType == 'looseleafOrtextbook') {//数字教材
                   type="12"
                }
            fetch(`${xueKeKnowledgeBase}/gw/web/login/verifyQuestionbankAuth?userId=${this.userId}&goodsId=${this.goodsId}&knowledgeType=${type}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(resolve => resolve.json())
                .then(data => {
                    if(process.env.VUE_APP_ENV=='development'){
                    this.openPage(res,true)
                    return true
                }
                    this.openPage(res,data.data.permission == 1)
                    
                   
                })
                .catch(error => {
                    console.error('请求出错:', error);
                    this.errorMessage = '请求验证服务失败'
                    return false
                });
            })

        },

        // 打开对应页面
        openPage(res,permission) {
            this.$store.commit("SET_ISLAYOUT", false);
            let info = {
                userId: this.userId,
                goodsId: this.goodsId,
                platform: this.platform,
                timestamp: this.timestamp
            }
            setBrowserToken(JSON.stringify(info))
                this.goodsInfo = res.data.goods || {}
                let version = "v2"
                
                if (res.data.sourceList[0]?.resourceType == "bank"&&permission) {// 题库
                    this.isAuthorized = true
                    this.errorMessage = "题库"
                    this.$router.replace({
                        path: "/bookstore/generateQuestion",
                        query: {
                            goodsId: this.goodsId,
                            resourceType: "goods",
                            resource: "bookCity",
                            relevanceId: this.goodsId,
                            bookName: this.goodsInfo.goodsTitle || "",
                        },
                    });
                } else if (res.data.goods.goodsType == 'paper'&&permission) {//试卷
                    this.isAuthorized = true
                    this.errorMessage = "试卷"
                    this.$router.replace({
                        path: "/bookstore/answer",
                        query: {
                            goodsId: this.goodsId,
                            resourceType: "goods",
                            resource: "bookCity",
                            relevanceId: this.goodsId,
                            bookName: this.goodsInfo.goodsTitle || "",
                        },
                    });
                } else if (res.data.goods.goodsType == 'looseleafOrtextbook') {//数字教材
                    if (res.data.sourceList[0]?.sourceType == "V3") {
                        version = "v3";
                    }
                    this.isAuthorized = true
                    this.errorMessage = "数字教材"
                    this.$router.replace({
                        path: "/booksRead-mobile",
                        query: {
                            pageType: "pc",
                            businessType: "textBook",
                            resource: "bookCity",
                            textBookId: res.data.sourceList[0].filesId,
                            bookName: this.goodsInfo.goodsTitle || "",
                            isTrial: permission==false,
                            source: version,
                            goodsId:this.goodsId
                        },
                    });
                }else{
                    this.errorMessage = '未有该内容的使用权限'
                    return false
                }

        },

        // 重新验证
        retryAuth() {
            this.isAuthorized = false
            this.errorMessage = ''
            this.verifySignature()
        }
    },
    mounted() {
        /**
         * 试卷
         http://localhost:8080/#/wisdom-training?userId=123&goodsId=1987714096883175424&platform=xueKeKnowledgeBaseSys&browserFinger=f7l11u&timestamp=1762485702690&sign=51A3887C9076BBE6F020B58813DF4580
         * 题库
         http://localhost:8080/#/wisdom-training?userId=123&goodsId=1987709700673769472&platform=xueKeKnowledgeBaseSys&browserFinger=f7l11u&timestamp=1762485702690&sign=CFA5305A6ACF6ABA98E3C008D185119F
         * 数字教材
         http://localhost:8080/#/wisdom-training?userId=123&goodsId=1897932151983312896&platform=xueKeKnowledgeBaseSys&browserFinger=f7l11u&timestamp=1762485702690&sign=A28F5849B8ED500B44FEB8019A7A844F


         */
        this.verifySignature()
    }
}
</script>

<style scoped>
.wisdom-training {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
}

.auth-failed {
    text-align: center;
    padding: 40px;
    background-color: #fff1f0;
    border: 1px solid #ffccc7;
    border-radius: 8px;
}

.auth-failed h2 {
    color: #cf1322;
    margin-bottom: 20px;
}

.auth-failed p {
    color: #595959;
    margin-bottom: 20px;
}

.auth-failed button {
    padding: 8px 24px;
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.auth-failed button:hover {
    background-color: #40a9ff;
}

.auth-success {
    text-align: center;
    padding: 40px;
    background-color: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 8px;
}

.auth-success h2 {
    color: #389e0d;
    margin-bottom: 20px;
}

.auth-success p {
    color: #595959;
    margin-bottom: 20px;
}

.training-content {
    margin-top: 30px;
    padding: 20px;
    background-color: #fafafa;
    border-radius: 4px;
    text-align: left;
}
</style>